import { UserRegistration } from "./userRegistration";
import { ValidationCriterion } from "./validationCriterion";

export type UserRegistrationForm = UserRegistration & {
  passwordConfirmation: string;
};

export enum TextInputField {
  Username = "username",
  FirstName = "firstName",
  LastName = "lastName",
  PreferredName = "preferredName",
  Email = "email",
  Password = "password",
  PasswordConfirmation = "passwordConfirmation",
}

export type RegistrationInputValidation = {
  isValid: boolean;
  validations: ValidationCriterion[];
  errorMessage?: string;
};

export type RegistrationInputValidationMap = Record<
  TextInputField,
  RegistrationInputValidation
>;

export type InlineError = Partial<Record<TextInputField, string>>;
